module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('data-table', {
    attrs: {
      "title": "Tickets",
      "table-ref": "tickettable",
      "icon": "fa fa-headset",
      "title-heading": _vm.titleHeading,
      "url": _vm.url,
      "fields": _vm.fields,
      "sort-field": "target",
      "options": _vm.options,
      "add-action": _vm.action,
      "add-props": _vm.addProps,
      "bottom-comp": _vm.bottomComp,
      "bottom-comp-props": _vm.bottomCompProps,
      "search-placeholder": "Priority, Category, Type, Sub-Type...",
      "detail-component": "ticket-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "shortName",
      fn: function(props) {
        return [_c('org-badge', {
          attrs: {
            "organisation": props.rowData.organisation
          }
        })]
      }
    }, {
      key: "contractor",
      fn: function(props) {
        return [(props.rowData.contractor) ? _c('org-badge', {
          attrs: {
            "organisation": props.rowData.contractor
          }
        }) : _vm._e()]
      }
    }, {
      key: "opened",
      fn: function(props) {
        return [(props.rowData.opened) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "left"
          }
        }, [(props.rowData.opened || props.rowData.target) ? _c('table', [(props.rowData.opened) ? _c('tr', [_c('td', [_vm._v("Opened")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatDate(props.rowData.opened)))])])]) : _vm._e(), _vm._v(" "), (props.rowData.target) ? _c('tr', [_c('td', [_vm._v("Target")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatDate(props.rowData.target)))])])]) : _vm._e(), _vm._v(" "), (props.rowData.completedDate) ? _c('tr', [_c('td', [_vm._v("Completed")]), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatDate(props.rowData.completedDate)))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(props.rowData.days))])], 1) : _vm._e()]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63464f18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/TicketsTable.vue
// module id = 1605
// module chunks = 0